export default __webpack_public_path__ + "static/media/y_wdt_c_4.ff3ded10.mp3";